import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HTTPError } from 'ky';
import { useSession } from 'next-auth/react';
import { ShopTypes } from '~/lib/data-contract';
import { setUsersList } from '../../operations/mit-fog';

export default function useSetUsersList() {
    const { data } = useSession();
    const token = data?.accessToken ?? null;

    const queryClient = useQueryClient();
    return useMutation<ShopTypes.EditUserRequest, HTTPError | Error, Arguments>(
        ({ users }) => {
            return setUsersList({ users, token });
        },

        {
            onSuccess: (_, variables) => {
                queryClient.invalidateQueries([
                    'userList',
                    { customerId: variables.users.customerId },
                ]);
            },
        },
    );
}

type Arguments = { users: ShopTypes.EditUserRequest };
